import axios from "axios"; 

export default function ElasticSearch() {
  return {
    axiosRequest(method, url, body) {
      return axios({
        method: method,
        baseURL: url,
        data: JSON.stringify(body),
        crossDomain: true,
        withCredentials: true,
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
        }
      }).then(response => {
        return response
      });
      // where catch?
    }
  }
}
